/**
 * Sentry error monitoring (iter92.D)
 *
 * Solo se inicializa cuando estamos en producción (hostname coincide con
 * app.luisherreraeventos.es) — decisión usuario: ahorrar cuota free tier.
 *
 * Captura solo errores JS (no performance traces, no session replay) para
 * minimizar consumo y mantenernos cómodamente dentro de los 5.000 eventos/mes
 * gratuitos.
 *
 * Este módulo se IMPORTA EL PRIMERO desde index.js antes de cualquier otro
 * import, para garantizar que errores tempranos de carga se capturan.
 */

import * as Sentry from '@sentry/react';

const PRODUCTION_HOSTNAMES = [
  'app.luisherreraeventos.es',
];

const dsn = process.env.REACT_APP_SENTRY_DSN;
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isProduction = PRODUCTION_HOSTNAMES.includes(hostname);

if (dsn && isProduction) {
  Sentry.init({
    dsn,
    environment: 'production',
    // Solo errores — desactivamos performance traces y session replay
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    // Filtros para reducir ruido y proteger datos sensibles
    beforeSend(event, hint) {
      // Ignorar errores de extensiones del navegador
      const error = hint?.originalException;
      const stack = error?.stack || '';
      if (
        stack.includes('chrome-extension://') ||
        stack.includes('moz-extension://') ||
        stack.includes('safari-extension://')
      ) {
        return null;
      }
      // Limpiar headers sensibles si llegan en algún breadcrumb
      if (event.request?.headers) {
        delete event.request.headers.authorization;
        delete event.request.headers.cookie;
      }
      return event;
    },
    // Errores conocidos que ignoramos (ruido)
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      // Errores de red transitorios — el usuario simplemente reintenta
      'Network Error',
      'Failed to fetch',
      'NetworkError when attempting to fetch resource',
      'Load failed',
    ],
  });
   
  console.info('[Sentry] ✅ Initialized for production');
} else {
   
  console.info(`[Sentry] ⏭️  Skipped (hostname=${hostname}, dsn_set=${Boolean(dsn)})`);
}

export default Sentry;
